<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-data-table :loading="carregando ? 'success' : null" no-data-text="Nenhum(a) Feriado encontrado(a)!"
          loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunasFeriados"
          :header-props="headerProps" :items="listaFeriados" :items-per-page="-1" hide-default-footer
          class="elevation-0">
          <template v-slot:top>
            <v-row>
              <v-col class="botao-novo" cols="12" sm="12" md="12">
                <v-btn class="btn-novo-feriado" @click="abrirModalFeriados()">
                  <v-icon>mdi-plus</v-icon>
                  NOVO
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="mx-2" x-small fab color="success" @click="abrirModalFeriadosParaEdicao(item)"
              title="Editar Feriado">
              <v-icon class="mx-2" small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="mx-2" x-small fab color="error" @click="excluirFeriado(item)" title="Excluir Feriado">
              <v-icon class="mx-2" small>mdi-minus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="modalFeriados" max-width="900px" class="feriado-modal">
      <div class="feriado-modal-container">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon class="header-icon-white">{{ iconeTituloFeriados }}</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">{{ tituloFeriados }}</h2>
                <p class="header-subtitle">Configure os feriados da agenda</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <validation-observer ref="observerFeriados" v-slot="{ }">
                <v-form>
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <soi-input type="date" :name="'Data'" v-model="feriadoAgenda.data" :label="'Data'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <soi-input :name="'Descrição'" v-model="feriadoAgenda.descricao" :label="'Descrição'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                  </v-row>
                </v-form>
              </validation-observer>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()" :loading="carregando">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando" :disabled="carregando">
                  <v-icon left>$saveIcon</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import { AlertaExclusaoQuestaoBooleano, MensagemMixin } from '../../helpers/MensagemHelper';
import FeriadoAgenda from '../../models/agenda/FeriadoAgenda';
import { AgendamentoService } from '../../services/AgendamentoService';

export default Vue.extend({
  name: 'soi-feriadoAgenda',
  props: {
    value: {
      type: Array as () => FeriadoAgenda[],
      required: true,
    },
    agenda: {
      type: Object as () => any,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      carregando: false,
      modalFeriados: false,
      editarFeriados: false,
      feriadoAgenda: new FeriadoAgenda(),
      listaFeriados: this.value,
      feriadoAgendaEdicaoIndex: -1,
      agendamentoService: new AgendamentoService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      colunasFeriados: [
        {
          text: 'Data',
          align: 'center',
          value: 'data',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Descriçao',
          align: 'center',
          value: 'descricao',
          filterable: true,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
        },
      ],
    };
  },
  computed: {
    tituloFeriados() {
      return this.editarFeriados ? 'Editar Feriados' : 'Criar Feriados';
    },
    iconeTituloFeriados() {
      return this.editarFeriados ? 'mdi-calendar-edit' : 'mdi-calendar-plus';
    },
  },
  watch: {
    value() {
      this.listaFeriados = this.value;
    },
  },
  methods: {
    abrirModalFeriados() {
      this.modalFeriados = true;
      this.feriadoAgenda = new FeriadoAgenda();
    },
    async salvar() {
      const valid = await (this.$refs.observerFeriados as any).validate();
      if (!valid) {
        return;
      }

      if (this.agenda) {
        const normalizarData = (dataStr: string): Date => {
          if (!dataStr) return new Date();
          let data: Date;
          if (dataStr.includes('/') && dataStr.split('/').length === 3) {
            const [dia, mes, ano] = dataStr.split('/');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else if (dataStr.includes('-') && dataStr.split('-').length === 3) {
            const [ano, mes, dia] = dataStr.split('-');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else {
            data = new Date(dataStr);
          }
          if (Number.isNaN(data.getTime())) {
            return new Date();
          }
          return new Date(data.getFullYear(), data.getMonth(), data.getDate());
        };

        const dataFeriadoDia = normalizarData(this.feriadoAgenda.data);

        if (this.agenda.listaBloqueios && this.agenda.listaBloqueios.length > 0) {
          const bloqueioNoDia = this.agenda.listaBloqueios.find((bloqueio: any) => {
            const dataInicioDia = normalizarData(bloqueio.dataInicio);
            const dataFimDia = normalizarData(bloqueio.dataFim);
            return dataFeriadoDia.getTime() >= dataInicioDia.getTime()
              && dataFeriadoDia.getTime() <= dataFimDia.getTime();
          });

          if (bloqueioNoDia) {
            const dataInicioNormalizada = normalizarData(bloqueioNoDia.dataInicio);
            const dataFimNormalizada = normalizarData(bloqueioNoDia.dataFim);
            const formatarDataNormalizada = (data: Date): string => {
              const dia = String(data.getDate()).padStart(2, '0');
              const mes = String(data.getMonth() + 1).padStart(2, '0');
              const ano = data.getFullYear();
              return `${dia}/${mes}/${ano}`;
            };
            const dataInicioFormatada = formatarDataNormalizada(dataInicioNormalizada);
            const dataFimFormatada = formatarDataNormalizada(dataFimNormalizada);
            MensagemMixin(5000, 'error', `Não é possível criar feriado. Existe um bloqueio neste dia: ${dataInicioFormatada} até ${dataFimFormatada}. Remova o bloqueio primeiro.`);
            return;
          }
        }

        if (this.agenda.listaBloqueiosHorariosEspecificos && this.agenda.listaBloqueiosHorariosEspecificos.length > 0) {
          const bloqueioHorarioNoDia = this.agenda.listaBloqueiosHorariosEspecificos.find((bloqueio: any) => {
            const dataBloqueioDia = normalizarData(bloqueio.data);
            return dataFeriadoDia.getTime() === dataBloqueioDia.getTime();
          });

          if (bloqueioHorarioNoDia) {
            const dataBloqueioNormalizada = normalizarData(bloqueioHorarioNoDia.data);
            const dia = String(dataBloqueioNormalizada.getDate()).padStart(2, '0');
            const mes = String(dataBloqueioNormalizada.getMonth() + 1).padStart(2, '0');
            const ano = dataBloqueioNormalizada.getFullYear();
            const dataFormatada = `${dia}/${mes}/${ano}`;
            MensagemMixin(5000, 'error', `Não é possível criar feriado. Existe um bloqueio de horário específico neste dia: ${dataFormatada}. Remova o bloqueio de horário primeiro.`);
            return;
          }
        }

        if (this.agenda && this.agenda.id) {
          try {
            this.carregando = true;
            const dataFeriado = normalizarData(this.feriadoAgenda.data);
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            let dataFoiAlterada = false;
            if (this.editarFeriados && this.feriadoAgendaEdicaoIndex !== -1) {
              const feriadoOriginal = this.listaFeriados[this.feriadoAgendaEdicaoIndex];
              const dataOriginalStr = feriadoOriginal.data;
              const dataOriginal = normalizarData(dataOriginalStr);
              dataFoiAlterada = dataFeriado.getTime() !== dataOriginal.getTime();
            }

            if ((!this.editarFeriados || dataFoiAlterada) && dataFeriado.getTime() >= hoje.getTime()) {
              let dataFormatada: string;
              const dataInput = this.feriadoAgenda.data;

              if (dataInput.includes('/')) {
                const partes = dataInput.split('/');
                if (partes.length === 3) {
                  const [dia, mes, ano] = partes;
                  dataFormatada = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
                } else {
                  dataFormatada = `${dataFeriado.getFullYear()}-${String(dataFeriado.getMonth() + 1).padStart(2, '0')}-${String(dataFeriado.getDate()).padStart(2, '0')}`;
                }
              } else if (dataInput.includes('-')) {
                const [dataPart] = dataInput.split('T');
                const [dataFormatadaPart] = dataPart.split(' ');
                dataFormatada = dataFormatadaPart;
              } else {
                dataFormatada = `${dataFeriado.getFullYear()}-${String(dataFeriado.getMonth() + 1).padStart(2, '0')}-${String(dataFeriado.getDate()).padStart(2, '0')}`;
              }

              const response = await this.agendamentoService.BuscarAgendamentos(
                this.agenda.id,
                dataFormatada,
                '',
                '',
                1,
                1,
              );

              if (response && response.data) {
                const temAgendamentos = (response.data.itens && response.data.itens.length > 0)
                  || (response.data.totalItens && response.data.totalItens > 0);

                if (temAgendamentos) {
                  const dia = String(dataFeriado.getDate()).padStart(2, '0');
                  const mes = String(dataFeriado.getMonth() + 1).padStart(2, '0');
                  const ano = dataFeriado.getFullYear();
                  const dataFormatadaExibicao = `${dia}/${mes}/${ano}`;
                  const acao = this.editarFeriados ? 'atualizar' : 'criar';
                  MensagemMixin(5000, 'error', `Não é possível ${acao} feriado. Existem agendamentos registrados no dia ${dataFormatadaExibicao}. Reagende ou cancele os agendamentos primeiro.`);
                  this.carregando = false;
                  return;
                }
              }
            }
          } catch (error) {
            console.error('Erro ao verificar agendamentos:', error);
          } finally {
            this.carregando = false;
          }
        }
      }

      this.feriadoAgenda.data = DateHelper.formataParaDiaMesAno(
        this.feriadoAgenda.data,
      );

      if (this.editarFeriados) {
        if (this.feriadoAgendaEdicaoIndex !== -1) {
          Object.assign(
            this.listaFeriados[this.feriadoAgendaEdicaoIndex],
            this.feriadoAgenda,
          );
        }
      } else {
        this.listaFeriados.push(this.feriadoAgenda);
      }

      this.$emit('input', this.listaFeriados);
      this.modalFeriados = false;
      this.editarFeriados = false;
      this.feriadoAgenda = new FeriadoAgenda();
      await (this.$refs.observerFeriados as any).reset();
    },
    async abrirModalFeriadosParaEdicao(feriado: FeriadoAgenda) {
      this.feriadoAgendaEdicaoIndex = this.listaFeriados.indexOf(feriado);
      this.editarFeriados = true;
      this.modalFeriados = true;
      setTimeout(() => {
        this.feriadoAgenda = { ...feriado };
        this.feriadoAgenda.data = DateHelper.formatarParaAnosMesDiaSubstring(
          feriado.data,
        );
      }, 10);
    },
    async excluirFeriado(feriado: FeriadoAgenda) {
      if (await AlertaExclusaoQuestaoBooleano()) {
        const index = this.listaFeriados.indexOf(feriado);
        this.listaFeriados.splice(index, 1);
        this.$emit('input', this.listaFeriados);
      }
    },
    async fecharModal() {
      this.modalFeriados = false;
      this.editarFeriados = false;
      await (this.$refs.observerFeriados as any).reset();
      this.feriadoAgenda = new FeriadoAgenda();
    },
  },
});
</script>

<style scoped>
/* BOTÃO NOVO MODERNO */
.btn-novo-feriado {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  margin-bottom: 16px !important;
}

.btn-novo-feriado:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(46, 75, 157, 0.3) !important;
}

.btn-novo-feriado .v-icon {
  color: white !important;
  margin-right: 8px !important;
}

/* MODAL FERIADOS - ESTILO MODERNO */
.feriado-modal {
  z-index: 9999 !important;
}

.feriado-modal-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  margin: 0 auto;
}

/* HEADER MODERNO */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-text {
  flex: 1;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 4px 0 0 0;
  font-weight: 400;
}

/* CONTEÚDO UNIFICADO */
.unified-content {
  padding: 0 24px 24px 24px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 32px;
}

/* INPUTS MODERNOS */
.soi-input {
  margin-bottom: 16px;
}

.soi-input .v-input__control {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.soi-input .v-input__control:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

.soi-input .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.2) !important;
}

/* AÇÕES */
.form-actions {
  padding: 24px 32px 32px 32px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  min-width: 120px !important;
  height: 44px !important;
  transition: all 0.3s ease !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  border-color: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3);
}

.save-btn .v-icon {
  color: white !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .feriado-modal-container {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .form-content {
    padding: 24px;
  }

  .form-actions {
    padding: 20px 24px 24px 24px;
  }

  .actions-container {
    flex-direction: column;
  }

  .action-btn {
    width: 100% !important;
  }
}
</style>
